import { CmsConverterService } from '../../../cms/services/cms-converter/cms-converter.service'
import { CmsComponent } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { TrainingFacetComponentData } from './index'

@Injectable({ providedIn: 'root' })
export class TrainingFacetConverter extends CmsConverterService<TrainingFacetComponentData> {

  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      categories: formData.st_csod_categories?.value?.map((v: any) => {
        const { categoryId, categoryTitle } = v.value.target.dataset
        return { categoryId: `${categoryId}`, categoryTitle }
      }),
    }
  }
}
